// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.show-all-items[data-v-5080886e] {\n\tpointer-events: none;\n}\n.dropdown[data-v-5080886e] .dropdown-menu {\n\tz-index: 3;\n\twidth: 24rem;\n\tdisplay: none;\n}\n.dropdown.is-active[data-v-5080886e] .dropdown-menu {\n\tdisplay: block;\n}\n.dropdown[data-v-5080886e] .dropdown-content {\n\tmax-height: 213px;\n\toverflow-y: auto;\n}\n", ""]);
// Exports
module.exports = exports;
